// extracted by mini-css-extract-plugin
export default {"generalConditionL1":"HealthL3_generalConditionL1__h044B","smallPiegraph":"HealthL3_smallPiegraph__1+q7M"};